import { FormArray, FormControl, FormGroup } from "@angular/forms";
import { LevelEditorComponent } from "../../leveleditor.component";
import { v4 as uuidv4 } from 'uuid';
import { PointTool } from "./PointTool";
import { Geo } from "src/app/util/geo";
import { Camera } from "../../components/PointComponents/Camera";
import { PolygonMapComponent } from "../../components/PolygonComponents/PolygonMapComponent";
import { FabricHelpers } from "../../fabric.js/helpers";

export class CameraTool extends PointTool{
    constructor(editor: LevelEditorComponent, canvas: fabric.Canvas){
        super(editor, canvas);
    }

    public override CreateNew(canvasX : number, canvasY: number){
        const Lanes = this.editor.MapItemsByType.get('Lane');
        if(Lanes){
            for (let lane of Lanes) {
                var points = FabricHelpers.GetAdjustedXY(this.canvas, canvasX, canvasY);
                if (Geo.GetPolygonPointBounds((lane as PolygonMapComponent).formItem.get('PolygonPoints')?.value).Contains([points[0] / this.ScaleFactor, points[1] / this.ScaleFactor])) {     
                    let cameras = this.editor.ModelEditor.FormArray(lane.formItem, "Cameras");
                    let newCameraFormGroup = new FormGroup({
                        Id: new FormControl(uuidv4()),
                        Name: new FormControl("Camera"),
                        ActiveDirection: new FormControl(0),
                        DisplayAngle: new FormControl(0),
                        LocalAddress: new FormControl(null),
                        LocalPort: new FormControl(0),
                        Password: new FormControl(""),
                        SerialNumber: new FormControl(""),
                        Type: new FormControl(""),
                        Username: new FormControl(""),
                        LocationPoints: new FormControl(this.CreatePointFromXY(canvasX, canvasY)),
                        EditorLocked: new FormControl(false)
                    });

                    (cameras as FormArray).push(newCameraFormGroup);

                    var component = new Camera(this.editor, this.canvas, newCameraFormGroup, lane.formItem);
                    this.editor.Form.markAsDirty();
                    return component;
                }
            }
        }
        this.editor.toastService.error("Please place your Camera within a Lane");
        return null;
    }
}
